import React, { useState, useEffect } from 'react';
import { Link } from "react-router-dom";



export default function Navbar(props) {
    const [open, setOpen] = useState(false);
    const [scrolled, setScrolled] = useState(false)

    useEffect(() => {
      const  handleScroll = () => {
        setScrolled(window.scrollY >50);
      }
      window.addEventListener('scroll', handleScroll);

      return () => {
        window.removeEventListener('scroll', handleScroll);
    };
    },[]);
  return (
    <div className={`navbar ${scrolled ? 'scrolled' : ''}`}>
        <div className='logobox'>
            <h2 className='logo'>{props.logo}</h2>
        </div>
        <div className='hamburger' onClick={() => setOpen(!open)}>
        ☰
      </div>
        <div className={`navlinks ${open ? 'active' : ''}`}>
            <Link to="/" onClick={() => setOpen(false)}>Home</Link>
            <Link to= "/about" onClick={() => setOpen(false)}>About</Link>
            <Link to="/team" onClick={() => setOpen(false)}>Our Team</Link>
            <Link to="/courses" onClick={() => setOpen(false)}>Courses</Link>
            <Link to="/contact" onClick={() => setOpen(false)}>Contact</Link>
      </div>
      <div className='navbuttons'>
        <a className='button' href='https://wa.me/9082955754?text=Hello%20there!'>Get In Touch</a>
      </div>


    </div>
  )
}
